(function () {
  function currentSortValue() {
    return (
      document.querySelector(".facet-sort-select__input")?.value ||
      document.querySelector("#SortBy-mobile")?.value ||
      ""
    );
  }

  function applySort(value) {
    const mobileSelect = document.querySelector("#SortBy-mobile");
    if (mobileSelect && mobileSelect.value !== value) {
      mobileSelect.value = value;
      mobileSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const option = document.querySelector(
      '.facet-sort-select__option[data-value="' + value + '"]'
    );
    if (option) {
      option.click();
      return;
    }

    document.querySelectorAll('input[name="sort_by"]').forEach((input) => {
      input.value = value;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  function syncSortDrawer() {
    const value = currentSortValue();
    document.querySelectorAll("[data-fp-sort]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.fpSort === value);
    });
  }

  function setView(root, view) {
    root.setAttribute("data-product-view", view);
    try {
      localStorage.setItem("fp-product-view", view);
    } catch (error) {
      /* ignore */
    }
    document.querySelectorAll("[data-fp-view]").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.fpView === view);
    });
  }

  function filterDetails() {
    return document.querySelector(".fp-collection .mobile-facets__wrapper details");
  }

  function openFilters() {
    const details = filterDetails();
    if (!details) return;
    const summary = details.querySelector("summary");
    details.setAttribute("open", "");
    details.classList.add("menu-opening");
    summary?.setAttribute("aria-expanded", "true");
    document.body.classList.add("overflow-hidden-drawer");
  }

  function closeFilters() {
    const details = filterDetails();
    if (!details) return;
    const summary = details.querySelector("summary");
    details.classList.remove("menu-opening");
    details.removeAttribute("open");
    summary?.setAttribute("aria-expanded", "false");
    document.body.classList.remove("overflow-hidden-drawer");
  }

  function openSort() {
    syncSortDrawer();
    const drawer = document.getElementById("FpSortDrawer");
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("overflow-hidden");
  }

  function closeSort() {
    const drawer = document.getElementById("FpSortDrawer");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("overflow-hidden");
  }

  document.addEventListener("click", (event) => {
    const moreBtn = event.target.closest(".fp-view-more");
    if (moreBtn) {
      event.preventDefault();
      const wrap = moreBtn.closest(".facets__display, .mobile-facets__submenu");
      if (!wrap) return;
      const expanded = wrap.classList.toggle("fp-show-all");
      moreBtn.textContent = expanded ? "View Less" : "View More";
      moreBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    const viewBtn = event.target.closest("[data-fp-view]");
    if (viewBtn) {
      const root = document.getElementById("CollectionWrapper");
      if (root) setView(root, viewBtn.dataset.fpView);
    }

    if (event.target.closest("[data-fp-open-filters]")) {
      event.preventDefault();
      closeSort();
      openFilters();
    }

    if (event.target.closest("[data-fp-open-sort]")) {
      event.preventDefault();
      closeFilters();
      openSort();
    }

    if (event.target.closest("[data-fp-close-sort]")) {
      event.preventDefault();
      closeSort();
    }

    const sortBtn = event.target.closest("[data-fp-sort]");
    if (sortBtn) {
      applySort(sortBtn.dataset.fpSort);
      closeSort();
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const root = document.getElementById("CollectionWrapper");
    if (!root) return;

    let saved = "";
    try {
      saved = localStorage.getItem("fp-product-view") || "";
    } catch (error) {
      saved = "";
    }

    setView(root, saved || "grid");
    syncSortDrawer();
  });
})();
